<template>
  <div>
    <h1 class="page-header">
      Setup Location
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button color="info" outline @click="$router.push({ name: 'location-create' })">
              Add New
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input v-model="search" placeholder="Search" style="width: 300px;" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td>{{ record.location_name_kh }}</td>
          <td>{{ record.location_name_en }}</td>
          <td>{{ limitStringShow(record.description) }}</td>
          <td>
            <div class="checkbox checkbox-css">
              <input type="checkbox" id="cssCheckbox1" :checked="record.is_main_warehouse" disabled />
              <label for="cssCheckbox1"></label>
            </div>
          </td>
          <td class="text-center">
            <router-link
              :to="{
                name: 'location-edit',
                params: { id: record.location_id }
              }"
              title="edit"
              class="mr-2"
            >
              <i class="fas fa-edit"></i>
            </router-link>

            <a href="#" title="delete" class="text-danger" @click="destroy(record.location_id)">
              <i class="fas fa-trash"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'location',

  data() {
    return {
      loading: false,
      columns: [
        { name: 'location name kh' },
        { name: 'location name en' },
        { name: 'description' },
        { name: 'main warehouse' },
        { name: 'Actions', style: 'text-align:center' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administration/location', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administration.location.search
      },
      set(newValue) {
        this.$store.commit('administration/location/SET_SEARCH', newValue)
        this.$store.commit('administration/location/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administration/location/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async destroy(positon_id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('administration/location/destroy', positon_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
          })
          .catch(error => {
            this.$toasted.error(response.message)
          })
      }
    },
    limitStringShow(text) {
      if (text == null) return
      let article = this.stripTags(text)
      return article.length > 60 ? article.substring(0, 60) + '...' : article
    },
    stripTags(text) {
      return text.replace(/(<([^>]+)>)/gi, '')
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'location-create') {
      this.$store.commit('administration/location/RESET_STATE')
    }
    next()
  }
}
</script>
